import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/**
 * Auth UI now lives on account-web. This stub preserves old bookmarks
 * (pro.lionenergy.com/login?redirect=…) by bouncing to account.
 */
export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/login", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  component: () => null,
});
